// app/src/features/bugReport/BugReportHost.jsx
import React from "react";
import BugReportModal from "../../components/BugReportModal.jsx";

/**
 * The feedback / bug-report modal, rendered beside `AppFrame` (not a frame slot) for the phone
 * and the desktop layouts alike, as the inline mount was: feedback opens from anywhere
 * (`useBugReportTriggers`), the phone layout included. A fixed-position `ModalShell`, so its
 * order among the root div's children carries nothing.
 *
 * `ctx` is the frame context (`bugOpen` is all it reads); `bugReport` is the bug-report wiring's
 * `bugReportCtx`, the modal's own context, passed through untouched.
 */
export default function BugReportHost({ ctx, bugReport }) {
  const { bugOpen } = ctx;
  return bugOpen ? <BugReportModal ctx={bugReport} /> : null;
}
